import React, { FC } from "react"

export const TextArea: FC<{
    name: string
    placeholder: string
    value: string
    onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void
    error: string | undefined
    className:string
  }> = ({ name, placeholder, value, onChange, error,className }) => {
    return (
      <>
        <textarea
          className={className}
          name={name}
          rows={15}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
        />
        {error ? <div className="error">{error}</div> : null}
      </>
    )
  }


  export const TextInput: FC<{
    name: string
    type: string
    placeholder: string
    value: string
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
    error: string | undefined
    className:string
  }> = ({ name, type, placeholder, value, onChange, error,className }) => {
    return (
      <>
        <input
          className={className}
          name={name}
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
        />
        {error && <div className="error">{error}</div>}
      </>
    );
  }
  